export function DEBUG_setUuid(
  x: object,
  uuid: string | (() => string) = () =>
    performance.now().toFixed(0).padStart(6, "0"),
) {
  (x as unknown as { __uuid?: string }).__uuid =
    typeof uuid === "string" ? uuid : uuid();
}
export function DEBUG_getUuid(x: object) {
  return (x as unknown as { __uuid?: string }).__uuid;
}
